import { QueryFunctionContext } from '@tanstack/react-query'
import axios from 'axios'

import {
  ApiErrorResponse,
  ContentSharedLinkIdRequest,
  ContentSharedLinkResponse,
  CreateContentSharedLinkRequest,
  GetContentSharedLinkResponse,
} from '@tabeeb/contracts/main-api/swagger-main-api'
import { HttpGet, HttpPost, HttpPut } from '@tabeeb/shared/utils/API/httpClient'
import { ErrorCode } from '@tabeeb/enums'

export const ContentSharedLinkKeys = {
  contentSharedLink: 'contentSharedLink',
}

const contentSharedLinkControllerPath = 'api/contentSharedLink'

export interface GetContentSharedLinkRequestParams {
  contentId: number
  tenantId: number
}

export async function getContentSharedLinkRequest({
  queryKey,
}: QueryFunctionContext<[string, GetContentSharedLinkRequestParams]>): Promise<GetContentSharedLinkResponse> {
  const [_, params] = queryKey

  const response = await HttpGet<GetContentSharedLinkRequestParams, GetContentSharedLinkResponse>({
    path: `${contentSharedLinkControllerPath}`,
    params,
  })

  return response.data
}

export async function generateContentSharedLinkRequest(
  payload: CreateContentSharedLinkRequest
): Promise<ContentSharedLinkResponse> {
  const response = await HttpPost<CreateContentSharedLinkRequest, ContentSharedLinkResponse>({
    path: `${contentSharedLinkControllerPath}`,
    body: payload,
  })

  return response.data
}

export async function regenerateContentSharedLinkRequest(
  payload: ContentSharedLinkIdRequest
): Promise<ContentSharedLinkResponse> {
  const response = await HttpPut<ContentSharedLinkIdRequest, ContentSharedLinkResponse>({
    path: `${contentSharedLinkControllerPath}/regenerate`,
    body: payload,
  })

  return response.data
}

export async function revokeContentSharedLinkRequest(payload: ContentSharedLinkIdRequest): Promise<void> {
  const response = await HttpPut<ContentSharedLinkIdRequest, void>({
    path: `${contentSharedLinkControllerPath}/revoke`,
    body: payload,
  })

  return response.data
}

export async function introduceContentSharedLinkRequest(payload: ContentSharedLinkIdRequest): Promise<void> {
  const response = await HttpPut<ContentSharedLinkIdRequest, void>({
    path: `${contentSharedLinkControllerPath}/introduce`,
    body: payload,
  })

  return response.data
}
